import emitter from 'tiny-emitter/instance'
import { useLocationStore } from '@shared/store/location'
import { useConfigurationStore } from '@shared/store/configuration'
import { useBranchesStore } from '@shared/store/branches'
import { useProductsStore } from '@shared/store/products'
import { useSocketIOStore } from '@shared/store/socket-io'
import { registerSocketListeners } from '@shared/store/socket-listeners'
import { useExportsStore } from '@shared/store/exports'

/**
 * Resets tenant-scoped client state and notifies listeners after switching dashboards.
 * Called after dashboard navigation so tenant-scoped data loads on the target page.
 */
export async function applyTenantContextEffects() {
  const locationStore = useLocationStore()
  locationStore.resetForTenantSwitch()

  const configurationStore = useConfigurationStore()
  const branchesStore = useBranchesStore()
  const productsStore = useProductsStore()

  await Promise.all([
    configurationStore.loadTenantConfig(),
    configurationStore.loadBranchCurrencies(),
    branchesStore.checkBranchesCount(),
    productsStore.checkProductsCount()
  ])

  const app = globalThis.window?.app
  const vm = app?.config?.globalProperties
  const socketStore = useSocketIOStore()
  useExportsStore().timeOutExportsOnTenantSwitch()
  socketStore.closeConnection(vm)
  await socketStore.initConnection(vm)
  registerSocketListeners(vm)

  emitter.emit('refresh-requested')
}
